import PropTypes from 'prop-types';
import * as locales from 'constants/locales';

export const LangPropType = PropTypes.oneOf(Object.values(locales));
